import {
  AI_TOOLS_I18N,
  AI_TEMPLATE_TOOLS_I18N,
  AIToolsTranslations,
  AITemplateToolsTranslations,
} from '@beeboard/common';
import { createI18n } from 'vue-i18n';
import de from './de.json';
import en from './en.json';

const LOCALE_KEY = 'LOCALE';
export const DEFAULT_LANGUAGE = 'de';

/**
 * Merge AI tools translations from @beeboard/common into local translations.
 * Common owns the tool texts; the local files do not word them.
 */
export function mergeTranslations(
  local: Record<string, unknown>,
  ai: AIToolsTranslations,
  templateAi: AITemplateToolsTranslations,
): object {
  const localAi = local.ai as Record<string, unknown> | undefined;
  const localTools = localAi?.tools as Record<string, unknown> | undefined;

  return {
    ...local,
    ai: {
      ...(localAi || {}),
      tools: {
        ...(localTools || {}),
        definitions: ai.ai.tools.definitions,
        template_definitions: templateAi.ai.tools.template_definitions,
      },
    },
  };
}

const messages =
  import.meta.env.MODE === 'test'
    ? {}
    : ({
        en: mergeTranslations(en, AI_TOOLS_I18N.en, AI_TEMPLATE_TOOLS_I18N.en),
        de: mergeTranslations(de, AI_TOOLS_I18N.de, AI_TEMPLATE_TOOLS_I18N.de),
      } as { en: object; de: object });

export const isBrowser = () => typeof window !== 'undefined';

// const numberFormats: {
//   en: {
//     currencyFormat: {
//       style: 'currency',
//       currency: 'USD',
//       notation: 'standard',
//     },
//     decimal: {
//       style: 'decimal',
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     },
//     percent: {
//       style: 'percent',
//       useGrouping: false,
//     },
//   },
// };

// const pluralRules = (choice: any, choicesLength: any) => {
//   if (choice === 0) {
//     return 0;
//   }
//   const teen = choice > 10 && choice < 20;
//   const endsWithOne = choice % 10 === 1;
//   if (!teen && endsWithOne) {
//     return 1;
//   }
//   if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
//     return 2;
//   }
//   return choicesLength < 4 ? 2 : 3;
// };

export const i18n = createI18n({
  legacy: false, // set to `false`, if we use the Composition API in the future
  globalInjection: true, // has only effect when the Composition API is used
  warnHtmlMessage: false, // Disable warnings about HTML in messages
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: 'de',
  silentTranslationWarn: import.meta.env.MODE === 'test',
  silentFallbackWarn: import.meta.env.MODE === 'test',
  messages, // we load all messages at once, see here for doing better: https://vue-i18n.intlify.dev/guide/advanced/lazy
  // numberFormats,
  fallbackWarn: false, // Suppress log that a fallback is used, we still get one for a missing key
  // pluralRules,
});
export const $t = i18n.global.t;

export const setLocale = (locale: string) => {
  if (!isBrowser()) {
    return;
  }
  window.localStorage.setItem(LOCALE_KEY, locale);
};

export const getLocale = (): 'de' | 'en' => {
  if (!isBrowser()) {
    return DEFAULT_LANGUAGE;
  }

  return (i18n.global.locale.value =
    (window.localStorage.getItem(LOCALE_KEY) as 'de' | 'en') ||
    DEFAULT_LANGUAGE);
};

(() => {
  if (!isBrowser()) {
    return;
  }
  i18n.global.locale.value = getLocale();
})();
